import styled from 'styled-components';

const AutoPricingContainer = styled.div`
  margin-top: 32px;
`;

export default AutoPricingContainer;
